import { createContext, useContext } from "react";
import { useFetch } from "@/hooks/useFetch";

const SettingsContext = createContext(null);

const FALLBACK = { sales_people: [], job_types: [], companies: [], pay_rates: [], commission_rates: [], teams: [], subbies: [], trucks: [], fleet: [], lead_sources: [], truck_sizes: [], daily_capacity: 40 };

export function SettingsProvider({ children }) {
  const { data, reload, setData } = useFetch("/settings", undefined, { poll: false });
  return (
    <SettingsContext.Provider value={{ settings: data || FALLBACK, reload, setSettings: setData }}>
      {children}
    </SettingsContext.Provider>
  );
}

export const useSettings = () => useContext(SettingsContext);
